import { render, staticRenderFns } from "./ChallengerDetailCommunityUser.vue?vue&type=template&id=69efa042&scoped=true"
import script from "./ChallengerDetailCommunityUser.vue?vue&type=script&lang=ts"
export * from "./ChallengerDetailCommunityUser.vue?vue&type=script&lang=ts"
import style0 from "./ChallengerDetailCommunityUser.vue?vue&type=style&index=0&id=69efa042&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69efa042",
  null
  
)

export default component.exports